export default {
  apiUrl: 'https://dewildeapp.nl/api/v2',

  mediaBasePath: 'https://dewildeapp.nl',

  sentryDsn: 'https://1e29d220b9f747a3afaf2b9ca580965b@sentry.io/1549718',
};
